import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const session = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
